import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_SGU_DOMINIOS_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, CadastrarMensagemErroRequest } from './types';

// ACTIONS
import {
	cadastrarMensagemErroSuccess,
	cadastrarMensagemErroFailure,
} from './actions';

function* cadastrarMensagemErro(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: CadastrarMensagemErroRequest } = request;

	const body = { ...payload };

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_SGU_DOMINIOS_API,
		`mensagens-erro`,
		body,
		undefined,
		undefined,
		undefined,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastrarMensagemErroSuccess(response));
	} else {
		yield put(cadastrarMensagemErroFailure());
	}
}

export default all([
	takeLatest(Types.CADASTRAR_MENSAGEM_ERRO_REQUEST, cadastrarMensagemErro),
]);
